/** Display of arbitrary config values in read-only cells, diffs and reports. */
export const formatValue = (value: unknown): string => {
  if (value === undefined) return "";
  if (value === null) return "null";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value) && value.every((v) => typeof v === "string" || typeof v === "number")) return value.join(", ");
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

/** Multi-line JSON for read-only blocks. */
export const prettyJson = (value: unknown): string => {
  try {
    return JSON.stringify(value ?? null, null, 2);
  } catch {
    return String(value);
  }
};
